import { renderTeaserY } from '../../templates/teaser-y';
import { convertToImgixSrc } from './imgix';

export interface EnsemblesItem {
	id: number
	title: string
	date_begin?: string
	poster_image?: string
	poster_credits?: string
	actors: string
}

export function itemTeaser( id: string, item: EnsemblesItem ) {
	const teaser = renderTeaserY(
		convertToImgixSrc(
			item.poster_image,
			( params ) => {
				params.set( 'w', '305' );
				params.set( 'ar', '305:196' );
				params.set( 'fit', 'crop' );
				params.set( 'crop', 'faces' );
			}
		),
		[
			'280',
			'336',
			'403',
			'484',
			'581',
			'697',
			'836',
			'1040',
		].map( ( width ) => {
			const src = convertToImgixSrc(
				item.poster_image,
				( params ) => {
					params.delete( 'dpr' );
					params.set( 'w', width );
					params.set( 'ar', '305:196' );
					params.set( 'fit', 'crop' );
					params.set( 'crop', 'faces' );
				}
			);

			if ( !src ) return null;

			return `${src} ${width}w`;
		} ).filter( Boolean ) as Array<String>,
		item.title,
		item.actors,
		item.date_begin || '',
		item.id.toString(),
		`ensembles-event-detail-dialog-${id}`
	);

	teaser.classList.add( 'artworks-list__item' );

	return teaser;
}
